module.exports = __webpack_public_path__ + "img/logo_play.cebcf2f0.png";